import React from 'react';
import PropTypes from 'prop-types';

import PeopleIcon from '@mui/icons-material/People';
import { Tooltip } from '@mui/material';

import classes from './iconStyles.module.css';

const OnGroupIcon = ({ onClick, title }) => {
    return (
        <Tooltip title={title} placement={'top'}>
            <div className={classes.assigneeIcon} onClick={onClick}>
                <PeopleIcon aria-label="group-icon" />
            </div>
        </Tooltip>
    );
};

OnGroupIcon.propTypes = {
    onClick: PropTypes.func,
    title: PropTypes.string
};

export default OnGroupIcon;
